import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import uiReducer from '@features/ui/UiSlice';
import calendarReducer from '@features/calendar/CalendarSlice';
import { scheduleApi } from '@features/api/ScheduleApiSlice';

const store = configureStore({
  reducer: {
    ui: uiReducer,
    calendar: calendarReducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([scheduleApi.middleware]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
